module.exports = __webpack_public_path__ + "static/media/left-bg.14e811fb.png";